import { AssessmentProgram } from "@lib/ShiOneClient";

export const determineProgram = (programString: string) => {
  switch (programString) {
    case "security-posture-review":
      return AssessmentProgram.SecurityPostureReview;
    case "ai-readiness":
      return AssessmentProgram.AiReadiness;
    case "microsoft-adoption-assessment":
      return AssessmentProgram.MicrosoftAdoptionAssessment;
    case "dev-ops-posture-review":
      return AssessmentProgram.DevOpsPostureReview;
    case "aws-maturity-review":
      return AssessmentProgram.AwsMaturity;
    default:
      return AssessmentProgram.Unknown;
  }
};
